import {
  TiptapBase,
  Heading,
  Blockquote,
  BulletList,
  OrderedList,
  Bold,
  Color,
  Italic,
  Strike,
  Highlight,
  History,
  FontFamily,
  FontSize,
  LineHeight,
  Link,
  Underline,
  TextAlign,
  HardBreak,
  HorizontalRule,
  ListItem,
  Dropcursor,
  Gapcursor,
  TextStyle,
  Tables,
  Margins,
  PasteFromGoogleDocs,
  UpdateContent,
  AutoSaveContract,
} from '@/js/util/tiptap/extensions';

import {
  BlockquoteHandlers,
  FontFamilyHandlers,
  FontSizeHandlers,
  HeadingLevelHandlers,
  HighlightHandlers,
  HistoryHandlers,
  HorizontalRuleHandlers,
  LineHeightHandlers,
  LinksHandlers,
  MarginHandlers,
  ListsHandlers,
  TableHandlers,
  TextAlignmentHandlers,
  TextColorHandlers,
  TextFormattingHandlers,
  PresetHandlers,
} from '@/js/util/tiptap/handlers';

export default class ContractEditorConfig {
  get extensions() {
    return [
      ...TiptapBase,
      ...Heading,
      ...Blockquote,
      ...BulletList,
      ...OrderedList,
      ...Bold,
      ...Color,
      ...Italic,
      ...Strike,
      ...Highlight,
      ...History,
      ...FontFamily,
      ...FontSize,
      ...LineHeight,
      ...Link,
      ...Underline,
      ...TextAlign,
      ...HardBreak,
      ...HorizontalRule,
      ...ListItem,
      ...Dropcursor,
      ...Gapcursor,
      ...TextStyle,
      ...Tables,
      ...Margins,
      ...PasteFromGoogleDocs,
      ...UpdateContent,
      ...AutoSaveContract,
    ];
  }

  get handlers() {
    return {
      ...BlockquoteHandlers,
      ...FontFamilyHandlers,
      ...FontSizeHandlers,
      ...HeadingLevelHandlers,
      ...HighlightHandlers,
      ...HistoryHandlers,
      ...HorizontalRuleHandlers,
      ...LineHeightHandlers,
      ...LinksHandlers,
      ...MarginHandlers,
      ...ListsHandlers,
      ...TableHandlers,
      ...TextAlignmentHandlers,
      ...TextColorHandlers,
      ...TextFormattingHandlers,
      ...PresetHandlers,
    };
  }
}
